import { render, staticRenderFns } from "./d-player.vue?vue&type=template&id=54f3f343&"
import script from "./d-player.vue?vue&type=script&lang=js&"
export * from "./d-player.vue?vue&type=script&lang=js&"
import style0 from "./d-player.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports